<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'
const store = useAppStore()

const isPointer = ref(false)

onMounted(async () => {
  await nextTick(() => {
    if (window) {
      isPointer.value = window.matchMedia('(pointer:fine)').matches
    }
  })
})
</script>

<template>
  <div class="overflow-x-hidden">
    <Header />
    <main>
      <slot />
    </main>
    <Footer :data="store" />
    <ClientOnly>
      <MouseCursor v-if="isPointer" />
    </ClientOnly>
  </div>
</template>
